var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisedRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 32C3.92 32 3.16693 31.6869 2.5408 31.0608C1.91467 30.4347 1.60107 29.6811 1.6 28.8V10.76C1.12 10.4667 0.733333 10.0869 0.44 9.6208C0.146667 9.15467 0 8.6144 0 8V3.2C0 2.32 0.3136 1.56693 0.9408 0.9408C1.568 0.314667 2.32107 0.00106667 3.2 0H28.8C29.68 0 30.4336 0.3136 31.0608 0.9408C31.688 1.568 32.0011 2.32107 32 3.2V8C32 8.61333 31.8533 9.1536 31.56 9.6208C31.2667 10.088 30.88 10.4672 30.4 10.7584V28.8C30.4 29.68 30.0869 30.4336 29.4608 31.0608C28.8347 31.688 28.0811 32.0011 27.2 32H4.8ZM4.8 11.2V28.8H27.2V11.2H4.8ZM3.2 8H28.8V3.2H3.2V8ZM11.2 19.2H20.8V16H11.2V19.2Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedRequests);
export default __webpack_public_path__ + "static/media/raised-requests.e87c127a216d89c4ece0e209552effbb.svg";
export { ForwardRef as ReactComponent };